import { SortOptions } from '@/shared/types/common';

export const pushNotificationsSort: SortOptions[] = [
  {
    id: '1',
    title: 'Date',
    options: [
      { label: 'Newest', value: 'createdAt:desc' },
      { label: 'Oldest', value: 'createdAt:asc' },
    ],
  },
];
